import { ModelBase } from '../abstract/model-base.model';
import { Moment } from 'moment';

export class RecentlyUploadedDocument extends ModelBase {

    /*----------------------------------------------------------------------------------------
     * Propriétés privées
     ----------------------------------------------------------------------------------------*/

    private _invoiceType!: string; // [sales|purchase]_[invoice|credit_note]
    private _issueDate!: Moment;
    private _reference!: string;
    private _grossAmount!: number;
    private _fileId!: number;
    private _partnerName!: string;

    /*----------------------------------------------------------------------------------------
     * Accesseurs
     ----------------------------------------------------------------------------------------*/

    public get invoiceType(): string {
        return this._invoiceType;
    }

    public set invoiceType(value: any) {
        this._setValue('_invoiceType', value, 'string');
    }

    public get issueDate(): Moment {
        return this._issueDate;
    }

    public set issueDate(value: any) {
        this._setValue('_issueDate', value, 'date');
    }

    public get reference(): string {
        return this._reference;
    }

    public set reference(value: any) {
        this._setValue('_reference', value, 'string');
    }

    public get grossAmount(): number {
        return this._grossAmount;
    }

    public set grossAmount(value: any) {
        this._setValue('_grossAmount', value, 'float');
    }

    public get fileId(): number {
        return this._fileId;
    }

    public set fileId(value: any) {
        this._setValue('_fileId', value, 'integer');
    }

    public get partnerName(): string {
        return this._partnerName;
    }

    public set partnerName(value: any) {
        this._setValue('_partnerName', value, 'string');
    }

    /*----------------------------------------------------------------------------------------
     * Méthodes publiques
     ----------------------------------------------------------------------------------------*/

    public get documentType(): 'sales' | 'purchasing' {
        return this.invoiceType.startsWith('sales') ? 'sales' : 'purchasing';
    }

    public get documentTypeLabel(): string {
        if (this.invoiceType.includes('credit_note')) {
            return this.documentType === 'sales' ? 'Avoir client' : 'Avoir fournisseur';
        } else {
            return this.documentType === 'sales' ? 'Facture client' : 'Facture fournisseur';
        }
    }

    public get displayAmount(): number {
        if (this.invoiceType.includes('credit_note')) {
            return -this.grossAmount;
        } else {
            return this.grossAmount;
        }
    }

    public get typeIcon(): string {
        if (this.invoiceType.includes('credit_note')) {
            return this.documentType === 'sales' ? 'pi pi-file-minus' : 'pi pi-file-minus';
        } else {
            return this.documentType === 'sales' ? 'pi pi-file-invoice' : 'pi pi-shopping-cart';
        }
    }

}